
export const appAdminRoutes: any[] = [
    {
        index: true,
        path: "/admin/dashboard",
        section: "dashboard",
        sidebarProps: {
            displayText: "Dashboard",
            icon: 'dashboard',
        },
    },
    {
        index: true,
        path: "/admin/dailyEstimate",
        section: "dailyEstimate",
        sidebarProps: {
            displayText: "Daily Estimate",
            icon: 'event_available',
        },
    },
    {
        index: true,
        path: "/admin/appointments",
        section: "appointments",
        sidebarProps: {
            displayText: "Appointments",
            icon: 'service_toolbox',
        },
    },
    {
        index: true,
        path: "/admin/workorders",
        section: "workorders",
        sidebarProps: {
            displayText: "Work Orders",
            icon: 'assignment',
        },
    },
    {
        path: "/admin/vendormanagement",
        section: "vendormanagement",
        sidebarProps: {
            displayText: "Vendor Management",
            icon: 'storefront',
        },
        child: [
            {
                path: "/admin/vendors",
                section: "vendors",
                sidebarProps: {
                    displayText: "Vendors",
                },
            },
            {
                path: "/admin/purchase-orders",
                section: "purchaseorders",
                sidebarProps: {
                    displayText: "Purchase Orders",
                },
            },
            {
                path: "/admin/reorder-tire-items",
                section: "reordertireitems",
                sidebarProps: {
                    displayText: "Reorder Tire Items",
                },
            },
            {
                path: "/admin/reorder-wheel-items",
                section: "reorderwheelitems",
                sidebarProps: {
                    displayText: "Reorder Wheel Items",
                },
            },

        ],
    },
    {
        index: true,
        path: "/admin/customerenquiries",
        section: "customerenquiries",
        sidebarProps: {
            displayText: "Customer Enquiries",
            icon: 'support_agent',
        },
    },
    {
        index: true,
        path: "/admin/emaillogs",
        section: "emaillogs",
        sidebarProps: {
            displayText: "Email Logs",
            icon: 'email',
        },
    },
]